import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const sandboxBundlerBifrostEntrypointsRoute: InvariantJiraRoute = {
	name: 'sandbox-bundler-bifrost-entrypoints',
	path: '/jira/software/sandbox/bundler-bifrost/entrypoints',
	exact: true,
};
